module.exports = __webpack_public_path__ + "static/media/IBM.95061fba.jpg";